import React, { useEffect, useState } from 'react'
import { useAxios } from '../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { REQUEST_STATUS, TOAST_DUCK } from '../../core/actions'
import { createVerifiedBankAccountAction, getVerifiedBankAccountAction } from '../../routes/financier/FinancierDuck'
import { errorSummary } from '../../utils/misc'
import Button from '../button'
import InputInlineWithLabel from '../inputInlineWithLabel'
import * as styles from './AddUpiAttributes.css'

export const AddUpiAttributes = ({ handleClose }) => {
  const { toastDispatch, financierDispatch } = useGlobalDispatch()

  const {
    financierState: { financier },
  } = useGlobal()
  const [vpa, setVpa] = useState('')
  const [holderName, setHolderName] = useState(financier?.financierBank?.holderName || financier?.financierName || '')
  const { authAxios } = useAxios()

  const [submitStatus, setSubmitStatus] = useState(REQUEST_STATUS.IDLE)

  useEffect(() => {
    setVpa(val => val.trim())
  }, [vpa])

  const successful_transaction = response => {
    console.log('Added bank details successfully', response)
    toastDispatch({
      type: TOAST_DUCK.SEND_TOAST,
      payload: { message: 'Changed bank details successfully', type: REQUEST_STATUS.SUCCESS },
    })
    setSubmitStatus(REQUEST_STATUS.SUCCESS)
    handleClose()
    getVerifiedBankAccountAction(financier?.financierPAN)(authAxios, financierDispatch)
  }
  const transaction_failed = ({ response }) => {
    console.log('Failed to add bank details', response?.data?.message)
    toastDispatch({
      type: TOAST_DUCK.SEND_TOAST,
      payload: {
        message: errorSummary(response?.data) || 'Unable to change bank details. Please try after some time.',
        type: REQUEST_STATUS.FAILURE,
      },
    })
    setSubmitStatus(REQUEST_STATUS.FAILURE)
  }

  const addUPIAccount = () => {
    setSubmitStatus(REQUEST_STATUS.PENDING)
    createVerifiedBankAccountAction(
      {
        vpa: vpa,
        account_holder_name: holderName,
      },
      financier?.financierPAN
    )(authAxios)(successful_transaction, transaction_failed)
  }

  return (
    <div>
      <div className={styles.upiAttributes}>
        <InputInlineWithLabel
          inputClass={styles.input}
          title={'VPA'}
          placeholder={'upi_id@okhdfcbank'}
          value={vpa}
          setValue={setVpa}
          message={''}
        />
        <InputInlineWithLabel
          inputClass={styles.input}
          title={'Account Holder Name'}
          placeholder={'Name associated with upi'}
          value={holderName}
          editable={false}
          setValue={setHolderName}
          message={''}
        />
      </div>
      <Button
        className={styles.button}
        label={submitStatus === REQUEST_STATUS.PENDING ? 'In Progress ...' : 'Add UPI Account'}
        handleClick={addUPIAccount}
        disabled={!vpa || !holderName || submitStatus === REQUEST_STATUS.PENDING}
      />
    </div>
  )
}
